<div class="onboarding-form">
  <h1>Get started</h1>
  @if (form) {
    <form
      [formGroup]="form"
      [boFormOptions]="options"
      (ngSubmit)="onSubmit()">
      <bo-non-field-errors />
      <app-form-field
        [boFieldPath]="'first_name'"
        [placeholder]="'Enter your first name'"
        [autocomplete]="'given-name'"></app-form-field>
      <app-form-field
        [boFieldPath]="'last_name'"
        [placeholder]="'Enter your last name'"
        [autocomplete]="'family-name'"></app-form-field>
      <app-form-field
        boFieldPath="idnum_type"
        label="Identity type"
        placeholder="Select your identity type"></app-form-field>
      @if (form.controls['idnum_type'].value === 1 || !form.controls['idnum_type'].value) {
        <app-id-field
          boFieldPath="idnum"
          placeholder="Enter identity number"
          label="Identity number"></app-id-field>
      }
      @if (form.controls['idnum_type'].value === 2) {
        <app-form-field
          boFieldPath="idnum"
          placeholder="Enter passport number"
          label="Passport number"></app-form-field>
      }
      <app-form-field
        [boFieldPath]="'date_of_birth'"
        [placeholder]="'Select your date of birth'"
        [label]="'Date of birth'"></app-form-field>
      <app-phone-field
        [boFieldPath]="'phone'"
        [autocomplete]="'tel-national'"
        [placeholder]="'00 000 000'"
        [label]="'Phone number'"></app-phone-field>
      <app-form-field
        [boFieldPath]="'email'"
        [placeholder]="'Enter your email address'"
        [label]="'Email address'"
        [autocomplete]="'email'"></app-form-field>
      <app-form-field
        [boFieldPath]="'consent'"
        label="I am authorised on behalf of the company to register for Paystashio."
        requiredErrorMsg="Consent from a director is required"></app-form-field>
      <app-form-field
        [boFieldPath]="'terms'"
        [labelTemplate]="termsLabel"
        requiredErrorMsg="The terms of usage and the privacy policy must be accepted">
        <ng-template #termsLabel>
          <span>
            I acknowledge that I agree to the
            <a
              class="text-secondary text-decoration-none"
              target="_blank"
              rel="noopener"
              routerLink="/terms-and-conditions">
              Terms of Use
            </a>
            ,
            <a
              class="text-secondary text-decoration-none"
              target="_blank"
              rel="noopener"
              routerLink="/prepaid-card-terms-and-conditions">
              Prepaid Card Terms and Conditions
            </a>
            and have read the
            <a
              class="text-secondary text-decoration-none"
              target="_blank"
              rel="noopener"
              routerLink="/privacy-policy">
              Privacy Policy </a
            >.
          </span>
        </ng-template>
      </app-form-field>
      <app-form-field
        boFieldPath="marketing"
        label="Keep me up to date with exciting Paystashio news and updates."></app-form-field>
      <app-submit
        btnID="signupGetStartedSubmitBtn"
        btnClass="btn-lg mt-4"
        iconClass="ms-2 iconoir-arrow-right"
        [busy]="busy"
        label="Continue"></app-submit>
      <app-router-switch-btn
        title="Login"
        urlLink="/login"></app-router-switch-btn>
    </form>
  } @else {
    <app-loader></app-loader>
  }
</div>
